// Configure run instance actions

export const SAVE_TYPOLOGY_SEGMENTS = 'SAVE_TYPOLOGY_SEGMENTS';
export const SAVE_TYPOLOGY_SEGMENTS_SUCCESS = 'SAVE_TYPOLOGY_SEGMENTS_SUCCESS';
export const SAVE_TYPOLOGY_SEGMENTS_FAIL = 'SAVE_TYPOLOGY_SEGMENTS_FAIL';

export function saveTypologySegments(payload) {
  return {
    type: SAVE_TYPOLOGY_SEGMENTS,
    payload
  };
}

export function saveTypologySegmentsSuccess(payload) {
  return {
    type: SAVE_TYPOLOGY_SEGMENTS_SUCCESS,
    payload
  };
}

export function saveTypologySegmentsFail(payload) {
  return {
    type: SAVE_TYPOLOGY_SEGMENTS_FAIL,
    payload
  };
}

export const FETCH_SCENARIO_TYPOLOGIES = 'FETCH_SCENARIO_TYPOLOGIES';
export const FETCH_SCENARIO_TYPOLOGIES_SUCCESS =
  'FETCH_SCENARIO_TYPOLOGIES_SUCCESS';
export const FETCH_SCENARIO_TYPOLOGIES_FAIL = 'FETCH_SCENARIO_TYPOLOGIES_FAIL';

export function fetchScenarioTypologies(payload) {
  return {
    type: FETCH_SCENARIO_TYPOLOGIES,
    payload
  };
}

export function fetchScenarioTypologiesSuccess(payload) {
  return {
    type: FETCH_SCENARIO_TYPOLOGIES_SUCCESS,
    payload
  };
}

export function fetchScenarioTypologiesFail(payload) {
  return {
    type: FETCH_SCENARIO_TYPOLOGIES_FAIL,
    payload
  };
}

// configure run instance END

export const FETCH_TRM_TYPOLOGIES = 'FETCH_TRM_TYPOLOGIES';
export const FETCH_TRM_TYPOLOGIES_SUCCESS = 'FETCH_TRM_TYPOLOGIES_SUCCESS';
export const FETCH_TRM_TYPOLOGIES_FAIL = 'FETCH_TRM_TYPOLOGIES_FAIL';

export function fetchTypologies(payload) {
  return {
    type: FETCH_TRM_TYPOLOGIES,
    payload
  };
}

export function fetchTypologiesSuccess(payload) {
  return {
    type: FETCH_TRM_TYPOLOGIES_SUCCESS,
    payload
  };
}

export function fetchTypologiesFail(payload) {
  return {
    type: FETCH_TRM_TYPOLOGIES_FAIL,
    payload
  };
}

export const CONFIRM_TRM_TYPOLOGIES = 'CONFIRM_TRM_TYPOLOGIES';
export const CONFIRM_TRM_TYPOLOGIES_SUCCESS = 'CONFIRM_TRM_TYPOLOGIES_SUCCESS';
export const CONFIRM_TRM_TYPOLOGIES_FAIL = 'CONFIRM_TRM_TYPOLOGIES_FAIL';

export function confirmUploadedTypologies(payload) {
  return {
    type: CONFIRM_TRM_TYPOLOGIES,
    payload
  };
}

export function confirmTypologiesSuccess(payload) {
  return {
    type: CONFIRM_TRM_TYPOLOGIES_SUCCESS,
    payload
  };
}

export function confirmTypologiesFail(payload) {
  return {
    type: CONFIRM_TRM_TYPOLOGIES_FAIL,
    payload
  };
}

export const DISCARD_TRM_TYPOLOGIES = 'DISCARD_TRM_TYPOLOGIES';

export function discardUploadedTypologies(payload) {
  return {
    type: DISCARD_TRM_TYPOLOGIES,
    payload
  };
}

export const CLEAR_UPLOAD_TYPOLOGIES = 'CLEAR_UPLOAD_TYPOLOGIES';

export function clearUploadTypologies(payload) {
  return {
    type: CLEAR_UPLOAD_TYPOLOGIES
  };
}

/*GET ALL SCENARIOS*/
export const FETCH_ALL_SCENARIOS = 'FETCH_ALL_SCENARIOS';
export const FETCH_ALL_SCENARIOS_SUCCESS = 'FETCH_ALL_SCENARIOS_SUCCESS';
export const FETCH_ALL_SCENARIOS_FAIL = 'FETCH_ALL_SCENARIOS_FAIL';

export function fetchAllScenarios(payload) {
  return {
    type: FETCH_ALL_SCENARIOS,
    payload
  };
}

export function fetchAllScenariosSuccess(payload) {
  return {
    type: FETCH_ALL_SCENARIOS_SUCCESS,
    payload
  };
}

export function fetchAllScenariosFail(payload) {
  return {
    type: FETCH_ALL_SCENARIOS_FAIL,
    payload
  };
}

/*GET SINGLE SCENARIO*/
export const FETCH_SINGLE_SCENARIO = 'FETCH_SINGLE_SCENARIO';
export const FETCH_SINGLE_SCENARIO_SUCCESS = 'FETCH_SINGLE_SCENARIO_SUCCESS';
export const FETCH_SINGLE_SCENARIO_FAIL = 'FETCH_SINGLE_SCENARIO_FAIL';
export const FETCH_SINGLE_SCENARIO_RESET = 'FETCH_SINGLE_SCENARIO_RESET';

export function fetchSingleScenario(payload) {
  return {
    type: FETCH_SINGLE_SCENARIO,
    payload
  };
}

export function fetchSingleScenarioSuccess(payload) {
  return {
    type: FETCH_SINGLE_SCENARIO_SUCCESS,
    payload
  };
}

export function fetchSingleScenarioFail(payload) {
  return {
    type: FETCH_SINGLE_SCENARIO_FAIL,
    payload
  };
}

export function fetchSingleScenarioReset(payload) {
  return {
    type: FETCH_SINGLE_SCENARIO_RESET,
    payload
  };
}

/*FETCH CHALLENGERS SUMMARY*/
export const FETCH_CHALLENGERS_SUMMARY = 'FETCH_CHALLENGERS_SUMMARY';
export const FETCH_CHALLENGERS_SUMMARY_SUCCESS =
  'FETCH_CHALLENGERS_SUMMARY_SUCCESS';
export const FETCH_CHALLENGERS_SUMMARY_FAIL = 'FETCH_CHALLENGERS_SUMMARY_FAIL';
export const FETCH_CHALLENGERS_SUMMARY_RESET =
  'FETCH_CHALLENGERS_SUMMARY_RESET';

export function fetchChallengersSummary(payload) {
  return {
    type: FETCH_CHALLENGERS_SUMMARY,
    payload
  };
}

export function fetchChallengersSummarySuccess(payload) {
  return {
    type: FETCH_CHALLENGERS_SUMMARY_SUCCESS,
    payload
  };
}

export function fetchChallengersSummaryFail(payload) {
  return {
    type: FETCH_CHALLENGERS_SUMMARY_FAIL,
    payload
  };
}

export function fetchChallengersSummaryReset(payload) {
  return {
    type: FETCH_CHALLENGERS_SUMMARY_RESET,
    payload
  };
}

/*REVERT_CHAMPION*/
export const REVERT_CURRENT_CHAMPION = 'REVERT_CURRENT_CHAMPION';
export const REVERT_CURRENT_CHAMPION_SUCCESS =
  'REVERT_CURRENT_CHAMPION_SUCCESS';
export const REVERT_CURRENT_CHAMPION_FAIL = 'REVERT_CURRENT_CHAMPION_FAIL';

export function revertCurrentChampion(payload) {
  return {
    type: REVERT_CURRENT_CHAMPION,
    payload
  };
}

export function revertCurrentChampionSuccess() {
  return {
    type: REVERT_CURRENT_CHAMPION_SUCCESS
  };
}

export function revertCurrentChampionFail() {
  return {
    type: REVERT_CURRENT_CHAMPION_FAIL
  };
}

/*REVERT_CHAMPION*/
export const PROMOTE_CHALLENGER = 'PROMOTE_CHALLENGER';
export const PROMOTE_CHALLENGER_SUCCESS = 'PROMOTE_CHALLENGER_SUCCESS';
export const PROMOTE_CHALLENGER_FAIL = 'PROMOTE_CHALLENGER_FAIL';

export function promoteChallenger(payload) {
  return {
    type: PROMOTE_CHALLENGER,
    payload
  };
}

export function promoteChallengerSuccess() {
  return {
    type: PROMOTE_CHALLENGER_SUCCESS
  };
}

export function promoteChallengerFail() {
  return {
    type: PROMOTE_CHALLENGER_FAIL
  };
}

/*CREATE SCENARIOS*/
export const CREATE_SINGLE_SCENARIO = 'CREATE_SINGLE_SCENARIO';
export const CREATE_SINGLE_SCENARIO_SUCCESS = 'CREATE_SINGLE_SCENARIO_SUCCESS';
export const CREATE_SINGLE_SCENARIO_FAIL = 'CREATE_SINGLE_SCENARIO_FAIL';
export const CREATE_SINGLE_SCENARIO_RESET = 'CREATE_SINGLE_SCENARIO_RESET';

export function createSingleScenario(payload) {
  return {
    type: CREATE_SINGLE_SCENARIO,
    payload
  };
}

export function createSingleScenarioSuccess(payload) {
  return {
    type: CREATE_SINGLE_SCENARIO_SUCCESS,
    payload
  };
}

export function createSingleScenarioFail(payload) {
  return {
    type: CREATE_SINGLE_SCENARIO_FAIL,
    payload
  };
}

export function createSingleScenarioReset(payload) {
  return {
    type: CREATE_SINGLE_SCENARIO_RESET,
    payload
  };
}

/*DELETE SCENARIO*/
export const DELETE_SINGLE_SCENARIO = 'DELETE_SINGLE_SCENARIO';
export const DELETE_SINGLE_SCENARIO_SUCCESS = 'DELETE_SINGLE_SCENARIO_SUCCESS';
export const DELETE_SINGLE_SCENARIO_FAIL = 'DELETE_SINGLE_SCENARIO_FAIL';

export function deleteSingleScenario(payload) {
  return {
    type: DELETE_SINGLE_SCENARIO,
    payload
  };
}

export function deleteSingleScenarioSuccess(payload) {
  return {
    type: DELETE_SINGLE_SCENARIO_SUCCESS,
    payload
  };
}

export function deleteSingleScenarioFail(payload) {
  return {
    type: DELETE_SINGLE_SCENARIO_FAIL,
    payload
  };
}

/*UPDATE SCENARIO*/
export const UPDATE_SINGLE_SCENARIO = 'UPDATE_SINGLE_SCENARIO';
export const UPDATE_SINGLE_SCENARIO_SUCCESS = 'UPDATE_SINGLE_SCENARIO_SUCCESS';
export const UPDATE_SINGLE_SCENARIO_FAIL = 'UPDATE_SINGLE_SCENARIO_FAIL';

export function updateSingleScenario(payload) {
  return {
    type: UPDATE_SINGLE_SCENARIO,
    payload
  };
}

export function updateSingleScenarioSuccess(payload) {
  return {
    type: UPDATE_SINGLE_SCENARIO_SUCCESS,
    payload
  };
}

export function updateSingleScenarioFail(payload) {
  return {
    type: UPDATE_SINGLE_SCENARIO_FAIL,
    payload
  };
}

/*ADD TYPOLOGY MAPPING TO SCENARIO*/
export const ADD_TYPOLOGY_TO_MAPPING = 'ADD_TYPOLOGY_TO_MAPPING';
export const ADD_TYPOLOGY_TO_MAPPING_SUCCESS =
  'ADD_TYPOLOGY_TO_MAPPING_SUCCESS';
export const ADD_TYPOLOGY_TO_MAPPING_FAIL = 'ADD_TYPOLOGY_TO_MAPPING_FAIL';

export function addTypologyToMapping(payload) {
  return {
    type: ADD_TYPOLOGY_TO_MAPPING,
    payload
  };
}

export function addTypologyToMappingSuccess(payload) {
  return {
    type: ADD_TYPOLOGY_TO_MAPPING_SUCCESS,
    payload
  };
}

export function addTypologyToMappingFail(payload) {
  return {
    type: ADD_TYPOLOGY_TO_MAPPING_FAIL,
    payload
  };
}

export const TRIGGER_SCENARIO_INIT = 'TRIGGER_SCENARIO_INIT';
export const TRIGGER_SCENARIO = 'TRIGGER_SCENARIO';
export const TRIGGER_SCENARIO_SUCCESS = 'TRIGGER_SCENARIO_SUCCESS';
export const TRIGGER_SCENARIO_FAIL = 'TRIGGER_SCENARIO_FAIL';

export function triggerScenariosInit() {
  return {
    type: TRIGGER_SCENARIO_INIT
  };
}

export function triggerScenarios(payload) {
  return {
    type: TRIGGER_SCENARIO,
    payload
  };
}

export function addTriggerScenarioSuccess(payload) {
  return {
    type: TRIGGER_SCENARIO_SUCCESS,
    payload
  };
}

export function addTriggerScenarioFail(payload) {
  return {
    type: TRIGGER_SCENARIO_FAIL,
    payload
  };
}

export const CREATE_CHALLENGER = 'CREATE_CHALLENGER';
export const CREATE_CHALLENGER_SUCCESS = 'CREATE_CHALLENGER_SUCCESS';
export const CREATE_CHALLENGER_FAIL = 'CREATE_CHALLENGER_FAIL';
export function createChallenger(payload) {
  return {
    type: CREATE_CHALLENGER,
    payload
  };
}

export function createChallengerSuccess() {
  return {
    type: CREATE_CHALLENGER_SUCCESS
  };
}

export function createChallengerFail() {
  return {
    type: CREATE_CHALLENGER_FAIL
  };
}

export const FETCH_TRM_TYPOLOGIES_OF_SCENARIO =
  'FETCH_TRM_TYPOLOGIES_OF_SCENARIO';
export const FETCH_TRM_TYPOLOGIES_OF_SCENARIO_SUCCESS =
  'FETCH_TRM_TYPOLOGIES_OF_SCENARIO_SUCCESS';
export const FETCH_TRM_TYPOLOGIES_OF_SCENARIO_FAIL =
  'FETCH_TRM_TYPOLOGIES_OF_SCENARIO_FAIL';

export function fetchTypologiesOfScenario(payload) {
  return {
    type: FETCH_TRM_TYPOLOGIES_OF_SCENARIO,
    payload
  };
}

export function fetchTypologiesOfScenarioSuccess(payload) {
  return {
    type: FETCH_TRM_TYPOLOGIES_OF_SCENARIO_SUCCESS,
    payload
  };
}

export function fetchTypologiesOfScenarioFail(payload) {
  return {
    type: FETCH_TRM_TYPOLOGIES_OF_SCENARIO_FAIL,
    payload
  };
}

export const FETCH_BLACKLIST = 'FETCH_BLACKLIST';
export const FETCH_BLACKLIST_SUCCESS = 'FETCH_BLACKLIST_SUCCESS';
export const FETCH_BLACKLIST_FAIL = 'FETCH_BLACKLIST_FAIL';

export function fetchBlackList(payload) {
  return {
    type: FETCH_BLACKLIST,
    payload
  };
}

export function fetchBlackListSuccess(payload) {
  return {
    type: FETCH_BLACKLIST_SUCCESS,
    payload
  };
}

export function fetchBlackListFail(payload) {
  return {
    type: FETCH_BLACKLIST_FAIL,
    payload
  };
}

export const PUT_TRM_TYPOLOGIES_OF_SCENARIO = 'PUT_TRM_TYPOLOGIES_OF_SCENARIO';
export const PUT_TRM_TYPOLOGIES_OF_SCENARIO_SUCCESS =
  'PUT_TRM_TYPOLOGIES_OF_SCENARIO_SUCCESS';
export const PUT_TRM_TYPOLOGIES_OF_SCENARIO_FAIL =
  'PUT_TRM_TYPOLOGIES_OF_SCENARIO_FAIL';

export function putTypologyOfScenariosListDataWorker(payload) {
  return {
    type: PUT_TRM_TYPOLOGIES_OF_SCENARIO,
    payload
  };
}

export function putTypologyOfScenariosListDataWorkerSuccess(payload) {
  return {
    type: PUT_TRM_TYPOLOGIES_OF_SCENARIO_SUCCESS,
    payload
  };
}

export function putTypologyOfScenariosListDataWorkerFail(payload) {
  return {
    type: PUT_TRM_TYPOLOGIES_OF_SCENARIO_FAIL,
    payload
  };
}

export const FETCH_CURRENT_CHAMPION = 'FETCH_CURRENT_CHAMPION';
export const FETCH_CURRENT_CHAMPION_SUCCESS = 'FETCH_CURRENT_CHAMPION_SUCCESS';
export const FETCH_CURRENT_CHAMPION_FAIL = 'FETCH_CURRENT_CHAMPION_FAIL';
export const FETCH_CURRENT_CHAMPION_RESET = 'FETCH_CURRENT_CHAMPION_RESET';

export function fetchCurrentChampion(payload) {
  return {
    type: FETCH_CURRENT_CHAMPION,
    payload
  };
}

export function fetchCurrentChampionSuccess(payload) {
  return {
    type: FETCH_CURRENT_CHAMPION_SUCCESS,
    payload
  };
}

export function fetchCurrentChampionFail(payload) {
  return {
    type: FETCH_CURRENT_CHAMPION_FAIL,
    payload
  };
}

export function fetchCurrentChampionReset(payload) {
  return {
    type: FETCH_CURRENT_CHAMPION_RESET,
    payload
  };
}

export const FETCH_CURRENT_CHALLENGER = 'FETCH_CURRENT_CHALLENGER';
export const FETCH_CURRENT_CHALLENGER_SUCCESS =
  'FETCH_CURRENT_CHALLENGER_SUCCESS';
export const FETCH_CURRENT_CHALLENGER_FAIL = 'FETCH_CURRENT_CHALLENGER_FAIL';

export function fetchCurrentChallenger(payload) {
  return {
    type: FETCH_CURRENT_CHALLENGER,
    payload
  };
}

export function fetchCurrentChallengerSuccess(payload) {
  return {
    type: FETCH_CURRENT_CHALLENGER_SUCCESS,
    payload
  };
}

export function fetchCurrentChallengerFail(payload) {
  return {
    type: FETCH_CURRENT_CHALLENGER_FAIL,
    payload
  };
}

export const REMOVE_TYPOLOGY_FROM_SCENARIO = 'REMOVE_TYPOLOGY_FROM_SCENARIO';

export function removeTypologyFromScenario(payload) {
  return {
    type: REMOVE_TYPOLOGY_FROM_SCENARIO,
    payload
  };
}

export const CLONE_SCENARIO = 'CLONE_SCENARIO';

export function cloneScenario(payload) {
  return {
    type: CLONE_SCENARIO,
    payload
  };
}

export const FETCH_RUN_INSTANCE_HISTORY = 'FETCH_RUN_INSTANCE_HISTORY';
export const FETCH_RUN_INSTANCE_HISTORY_SUCCESS =
  'FETCH_RUN_INSTANCE_HISTORY_SUCCESS';
export const FETCH_RUN_INSTANCE_HISTORY_FAIL =
  'FETCH_RUN_INSTANCE_HISTORY_FAIL';

export function fetchRunInstanceHistory(payload) {
  return {
    type: FETCH_RUN_INSTANCE_HISTORY,
    payload
  };
}

export function fetchRunInstanceHistorySuccess(payload) {
  return {
    type: FETCH_RUN_INSTANCE_HISTORY_SUCCESS,
    payload
  };
}

export function fetchRunInstanceHistoryFail(payload) {
  return {
    type: FETCH_RUN_INSTANCE_HISTORY_FAIL,
    payload
  };
}

export const FETCH_TICKETS = 'FETCH_TICKETS';
export const FETCH_TICKETS_SUCCESS = 'FETCH_TICKETS_SUCCESS';
export const FETCH_TICKETS_FAIL = 'FETCH_TICKETS_FAIL';

export function fetchTickets(payload) {
  return {
    type: FETCH_TICKETS,
    payload
  };
}

export function fetchTicketsSuccess(payload) {
  return {
    type: FETCH_TICKETS_SUCCESS,
    payload
  };
}

export function fetchTicketsFail(payload) {
  return {
    type: FETCH_TICKETS_FAIL,
    payload
  };
}

export const APPROVE_REJECT_TICKETS = 'APPROVE_REJECT_TICKETS';

export function approveRejectTickets(payload) {
  return {
    type: APPROVE_REJECT_TICKETS,
    payload
  };
}
